import validator from "validator";
import message from "../../../messages/auth";
import mobileValidator from "../../mobile";

const validateFirstName = (firstName) => {
  if (validator.isEmpty(firstName)) {
    return message.FIRST_NAME_DOSE_NOT_EXIST;
  }

  if (!firstName.trim().length) {
    return message.FIRST_NAME_DOSE_NOT_EXIST;
  }

  const regexFarsiCharter = /^[\u0600-\u06FF\s]+$/;
  if (!regexFarsiCharter.test(firstName)) {
    return message.FIRST_NAME_DOSE_NOT_FARSI_CHAR;
  }

  return true;
};

const validateLastName = (lastName) => {
  if (validator.isEmpty(lastName)) {
    return message.LAST_NAME_DOSE_NOT_EXIST;
  }

  if (!lastName.trim().length) {
    return message.LAST_NAME_DOSE_NOT_EXIST;
  }

  const regexFarsiCharter = /^[\u0600-\u06FF\s]+$/;
  if (!regexFarsiCharter.test(lastName)) {
    return message.LAST_NAME_DOSE_NOT_FARSI_CHAR;
  }

  return true;
};

const validateEmail = (email) => {
  if (validator.isEmpty(email)) {
    return message.EMAIL_DOSE_NOT_EXIST;
  }

  if (!email.trim().length) {
    return message.EMAIL_DOSE_NOT_EXIST;
  }
  if (!validator.isEmail(email)) {
    return message.EMAIL_INVALID;
  }

  return true;
};

const validateMobile = (mobile) => {
  if (validator.isEmpty(mobile)) {
    return message.USER_MOBILE_DOSE_NOT_EXIST;
  }

  if (!mobile.trim().length) {
    return message.USER_MOBILE_DOSE_NOT_EXIST;
  }

  if (!mobileValidator.isNumericMobile(mobile)) {
    return message.USER_MOBILE_WRONG;
  }

  if (!mobileValidator.validMobileNumber(mobile)) {
    return message.USER_MOBILE_WRONG;
  }

  return true;
};

const validatePassword = (password) => {
  if (validator.isEmpty(password)) {
    return message.PASSWORD_DOSE_NOT_EXIST;
  }

  if (!password.trim().length) {
    return message.PASSWORD_DOSE_NOT_EXIST;
  }

  const regexHasNumber = /\d/g;
  if (regexHasNumber.test(password)) {
    var regexHasLetter = /[a-zA-Z]/g;
    if (regexHasLetter.test(password)) {
      return true;
    } else {
      return message.PASSWORD_MUST_HAVE_ONE_LETTER;
    }
  } else {
    return message.PASSWORD_MUST_HAVE_ONE_NUMBER;
  }
};

const validationRegister = (info) => {
  const resValidateFirstName = validateFirstName(info.first_name);
  if (resValidateFirstName != true) {
    return resValidateFirstName;
  }
  const resValidateLastName = validateLastName(info.last_name);
  if (resValidateLastName != true) {
    return resValidateLastName;
  }
  const resValidateEmail = validateEmail(info.email);
  if (resValidateEmail != true) {
    return resValidateEmail;
  }
  const resValidateMobile = validateMobile(info.mobile);
  if (resValidateMobile != true) {
    return resValidateMobile;
  }
  const resValidatePassword = validatePassword(info.password);
  if (resValidatePassword != true) {
    return resValidatePassword;
  }
  const resValidateRepeatPassword = validatePassword(info.repeat_password);
  if (resValidateRepeatPassword != true) {
    return resValidateRepeatPassword;
  }

  if (info.password !== info.repeat_password) {
    return message.PASSWORD_DOSE_NOT_MATCH;
  }

  return true;
};

export default validationRegister;
